import { render } from "./localTabBar.vue?vue&type=template&id=1bde89b2&scoped=true"
import script from "./localTabBar.vue?vue&type=script&lang=js"
export * from "./localTabBar.vue?vue&type=script&lang=js"

import "./localTabBar.vue?vue&type=style&index=0&id=1bde89b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bde89b2"]])

export default __exports__